import React from 'react';
import { CTPAnsweredQuestion } from '../../types/compareThePair';

interface CTPSummaryTableProps {
  answeredQuestions: CTPAnsweredQuestion[];
  nameA: string;
  nameB: string;
  symbolA: string;
  symbolB: string;
  logoUrlA: string | null;
  logoUrlB: string | null;
}

export const CTPSummaryTable: React.FC<CTPSummaryTableProps> = ({
  answeredQuestions,
  nameA,
  nameB,
  symbolA,
  symbolB,
  logoUrlA,
  logoUrlB,
}) => {
  return (
    <div className="w-full max-w-md mx-auto mt-4 mb-4 rounded-xl overflow-hidden" style={{ backgroundColor: 'hsl(var(--card))' }}>
      {/* Header */}
      <div
        className="grid grid-cols-[1fr_minmax(70px,auto)_minmax(70px,auto)] items-end gap-1 px-3 py-3 border-b"
        style={{ borderColor: 'hsl(var(--border))' }}
      >
        <div className="text-xs font-medium uppercase tracking-wider" style={{ color: 'hsl(var(--muted-foreground))' }}>
          Metric
        </div>
        <div className="flex flex-col items-center gap-1 text-center">
          {logoUrlA ? (
            <img src={logoUrlA} alt={nameA} className="w-7 h-7 rounded-md object-contain" />
          ) : (
            <div
              className="w-7 h-7 rounded-md flex items-center justify-center text-xs font-bold text-white"
              style={{ backgroundColor: 'hsl(var(--muted))' }}
            >
              {symbolA[0]}
            </div>
          )}
          <span className="text-[10px] font-medium leading-tight" style={{ color: 'hsl(var(--muted-foreground))' }}>
            {symbolA}
          </span>
        </div>
        <div className="flex flex-col items-center gap-1 text-center">
          {logoUrlB ? (
            <img src={logoUrlB} alt={nameB} className="w-7 h-7 rounded-md object-contain" />
          ) : (
            <div
              className="w-7 h-7 rounded-md flex items-center justify-center text-xs font-bold text-white"
              style={{ backgroundColor: 'hsl(var(--muted))' }}
            >
              {symbolB[0]}
            </div>
          )}
          <span className="text-[10px] font-medium leading-tight" style={{ color: 'hsl(var(--muted-foreground))' }}>
            {symbolB}
          </span>
        </div>
      </div>

      {/* Metric rows */}
      {answeredQuestions.map(({ question }, i) => {
        const aIsBetter = question.lowerIsBetter
          ? question.rawValueA < question.rawValueB
          : question.rawValueA > question.rawValueB;
        const bIsBetter = !aIsBetter;

        return (
          <div
            key={i}
            className="grid grid-cols-[1fr_minmax(70px,auto)_minmax(70px,auto)] items-center gap-1 px-3 py-2 border-b last:border-b-0"
            style={{ borderColor: 'hsl(var(--border))' }}
          >
            <span className="text-xs font-medium truncate" style={{ color: 'hsl(var(--muted-foreground))' }}>
              {question.metricDisplayName}
            </span>
            <span
              className="text-xs font-mono text-center font-semibold"
              style={{ color: aIsBetter ? 'var(--ctp-correct)' : 'var(--ctp-wrong)' }}
            >
              {question.formattedValueA}
            </span>
            <span
              className="text-xs font-mono text-center font-semibold"
              style={{ color: bIsBetter ? 'var(--ctp-correct)' : 'var(--ctp-wrong)' }}
            >
              {question.formattedValueB}
            </span>
          </div>
        );
      })}
    </div>
  );
};
